// Author : Ayesha Shaikh
//  Date : 10 Dec 2024

import {
  Autocomplete,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Backdrop,
  Stack,
  CircularProgress,
  Chip,
  styled,
  TableContainer,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../components/Maincard";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useDateUtils } from "../../utils/formatTime";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DownloadIcon from "@mui/icons-material/Download";
import HeadingCard from "../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import SearchButton from "../../newTestPrep/newComponent/NewButtonComp/SearchButton";
import StyledTableContainer from "../../newTestPrep/newComponent/TableContainer";
import CustomPopup from "../../components/CustomPopup";

import { useGetTokenOrLogout } from "../../utils/token";
import LoaderComp from "../../newTestPrep/newComponent/LoaderComp/Loader";
import EnrollDetails from "../AllUserDashboards/popupComponent/EnrollDetails";
import MoreCardDetails from "../AllUserDashboards/popupComponent/MoreCardDetails";
import MiscellaneousComp from "../AllUserDashboards/popupComponent/MiscellaneousComp";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function TestTypeEnrollmentReport() {
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
       const countryId  =localStorage.getItem("employeeCountry")
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();
  const [monthList, setMonthList] = useState([]);
  const [monthname, setMonthName] = useState(null);
  const [selectedYear, setSelectedYear] = useState({
    year: new Date().getFullYear(),
  });
  const [branchList, setBranchList] = useState([]);
  const [advisorList, setAdvisorList] = useState([]);
  const [advisorName, setAdvisorName] = useState([{ user_id: "all" }]);
  const [allAdvisorList, setAllAdvisorList] = useState([]);
   const [countryList, setCountryList] = useState([]);
 const [countryName, setCountryName] = useState( parseInt(countryId));
  const [statusList, setStatusList] = useState([
    { id: 1, name: "Active" },
    { id: 0, name: "Inactive" },
  ]);
  const [status, setSatus] = useState([
 
  ]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [branchName, setBranchName] = useState([
 
  ]);
  const [selectedBranchId, setSelectedBranchId] = useState([]);
  const [revenueData, setRevenueData] = useState([]);
  const { currentMonthName } = useDateUtils();
  const [loading, setLoading] = useState(false);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}month`);
        if (response.ok) {
          const data = await response.json();

          setMonthList(data);
          const currentIndex = data.findIndex(
            (month) => month.month_full_name === currentMonthName
          );

          setCurrentMonthIndex(currentIndex !== -1 ? currentIndex : 0);
          setMonthName(data[currentIndex].month_full_name);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleNextMonth = () => {
    if (currentMonthIndex < monthList.length - 1) {
      const nextIndex = currentMonthIndex + 1;
      setCurrentMonthIndex(nextIndex);
      const monthName = monthList[nextIndex].month_full_name;
      setMonthName(monthName);
      handleSearchData(monthName);
    }
  };

  const handlePreviousMonth = () => {
    if (currentMonthIndex > 0) {
      const prevIndex = currentMonthIndex - 1;
      setCurrentMonthIndex(prevIndex);
      const monthName = monthList[prevIndex].month_full_name;
      setMonthName(monthName);
      handleSearchData(monthName);
    }
  };

  const years = Array.from({ length: 5 }, (_, index) => ({
    year: new Date().getFullYear() - 3 + index,
  }));

  const handleselectedYear = async (value) => {
    setSelectedYear(value);
  };

 useEffect(() => {
        fetch(`${API_ENDPOINT}country`)
          .then((response) => response.json())
          .then((data) => {
            const filteredCountry = data.filter(
              (i) => i.country_name === "India" || i.country_name === "Nepal"
            );
            setCountryList(filteredCountry);
          })
          .catch((error) => {
            console.error("Error fetching state:", error);
          });
      }, []);
    
   const handleChangeCountry = (e) => {
      setBranchName([])
      setSelectedBranchId([])
setAllAdvisorList([])
setAdvisorName([])
      setCountryName(e.target.value);
    };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch/bycountry/${countryName}`);
        if (response.ok) {
          const data = await response.json();
          setBranchList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [countryName]);

   const allBranchList =[{branch_name:"Select All"} ,...branchList]


  const handleBranchChange = (event, value) => {
    if (value.some((item) => item.branch_name === "Select All")) {
  
      setBranchName(branchList);
      setSelectedBranchId(branchList.map((i) => i.id));
    } else {
    
      setBranchName(value);
      setSelectedBranchId(value.map((i) => i.id));
    }
  };


  const allStatusList = [{ id: 2, name: "Both" }, ...statusList];
  const handleStatusChange = (e, value) => {
    if (value.some((item) => item.id === 2)) {
      const selectedIds = statusList.map((i) => i.id);
      setSatus(statusList);
      setSelectedStatus(selectedIds);
    } else {
      const selectedIds = value.map((i) => i.id);
      setSatus(value);
      setSelectedStatus(selectedIds);
    }
  };

  const handleSearchAdvisors = async (selectedStatus) => {
    const requestData = {
      status: selectedStatus,
          branch_id: selectedBranchId,
      country_id: countryName,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}advisor/bystutus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();
        // const reversedData = result.slice().reverse();
        setAdvisorList(result);
      } else {
        console.log("Server Error", "error");
        setAdvisorList([]);
      }
    } catch (error) {
      console.log("Server Error", "error");
      setAdvisorList([]);
    }
  };

  useEffect(() => {
    handleSearchAdvisors(selectedStatus);
  }, [selectedStatus, selectedBranchId, countryName]);

  useEffect(() => {
    const updatedList = [
      ...(advisorList.length > 1
        ? [
            {
              first_name:
                advisorName.length === advisorList.length
                  ? "Deselect All"
                  : "Select All",
            },
          ]
        : []),
      ...advisorList,
    ];
    setAllAdvisorList(updatedList);
  }, [advisorList, advisorName]);

  const handleUserChange = (event, value) => {
    if (value.some((item) => item.first_name === "Select All")) {
      // If "Select All" is selected, set all branches
      setAdvisorName(advisorList);
    } else if (value.some((option) => option.first_name === "Deselect All")) {
      setAdvisorName([]);
    } else {
      // If individual branches are selected, remove "Select All"
      setAdvisorName(value);
    }
  };
  // Select Advisor Automatic base on Branch
  useEffect(() => {
    if (!Array.isArray(advisorList)) {
      console.error("advisorList is not an array:", advisorList);
      return;
    }

    if (selectedBranchId.includes("all")) {
      setAdvisorName(advisorList);
    } else {
      const branchViseAdvisor = advisorList.filter((advisor) =>
        selectedBranchId.includes(advisor.branch_id)
      );
      setAdvisorName(branchViseAdvisor);
    }
  }, [selectedBranchId, advisorList]);

  // const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  //   marginTop: "20px",
  //   "& .MuiTableCell-head": {
  //     backgroundColor: "#abf7b1",
  //     fontWeight: 600,
  //     padding: "6px 14px",
  //     fontSize: "13px",
  //     color: "#000",
  //     textAlign: "center",
  //     fontFamily: "Poppins",
  //   },
  //   "& .MuiTableCell-body": {
  //     textAlign: "center",
  //     padding: "6px 14px",
  //     overflow: "hidden", // Hide overflowing content
  //     textOverflow: "ellipsis", // Show ellipsis when content overflows
  //     fontSize: "11px",
  //     whiteSpace: "normal", // Allow text to wrap inside the cell
  //     wordWrap: "break-word",
  //   },
  // }));

  const handleSearchData = async (month) => {
    if (userRole==="center_admin" && advisorName.length === 0) {
      showSnackbar("Please Select Advisor", "error");
      return;
    }
    const selectedAdvisor = advisorName.map((i) => i.user_id);
    setLoading(true);

    const requestData = {
      country_id :countryName,
      user_id: parseInt(userId),
      year: selectedYear?.year,
      report_for:
        userRole === "center_admin" && selectedAdvisor.includes("all")
          ? "all"
          : userRole === "center_admin" && !selectedAdvisor.includes("all")
          ? selectedAdvisor
          : null,
      month: month,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/enrollment-collection`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

        const result = await response.json();
      if (response.ok) {
      
        // const reversedData = result.slice().reverse();

        const totalEnrollments = result?.revenue_data.reduce(
          (acc, curr) => acc + curr.total_enrollments,
          0
        );
        const totalOnlineEnrollments = result?.revenue_data.reduce(
          (acc, curr) => acc + curr.online_enrollments,
          0
        );
        const totalOfflineEnrollments = result?.revenue_data.reduce(
          (acc, curr) => acc + curr.offline_enrollments,
          0
        );
        const totalRevenue = result?.revenue_data.reduce(
          (acc, curr) => acc + curr.collected_revenue,
          0
        );
        const testBookings = result?.revenue_data.reduce(
          (acc, curr) => acc + curr.test_bookings,
          0
        );
         const testRevenue = result?.revenue_data.reduce(
          (acc, curr) => acc + curr.test_revenue,
          0
        );

        const totalCollectedRevenue = result?.revenue_data.reduce(
          (acc, curr) => acc + curr.total_revenue,
          0
        );

        // Create the total object
        if (result?.revenue_data.length > 0) {
        const totalObject = {
          test_type: "TOTAL",
          sub_test_type: "",
           currency :result?.revenue_data[0]?.currency,
          total_enrollments: totalEnrollments,
          online_enrollments: totalOnlineEnrollments,
          offline_enrollments: totalOfflineEnrollments,
          collected_revenue: totalRevenue,
          test_bookings: testBookings,
          test_revenue: testRevenue,
          total_revenue:totalCollectedRevenue   //mis + test
        };
          // Append the total object using spread operator
        const updatedRevenueData = [...result?.revenue_data, totalObject];
           setRevenueData(updatedRevenueData);
        }
      
        else{
          setRevenueData(result?.revenue_data)
        }
     
        setLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        showSnackbar("Please select user", "error");
        setRevenueData([]);
        setLoading(false);
      } else if (response.status === 440) {
        navigate("/page440");
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setRevenueData([]);
        setLoading(false);
      } else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  useEffect(() => {
    handleSearchData(currentMonthName);
  }, []);

  const handleView = () => {
    const url = `/view-test-type-wise-report`;
    window.open(url, "_blank");
    const targetDataObject = {
      revenueData,
      advisorName,
      selectedYear,
      monthname,
      countryName
    };
    localStorage.setItem("targetdata", JSON.stringify(targetDataObject));
  };

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (
    headerName,
    headerFilter,
    testType,
    subTestType
  ) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      year: selectedYear?.year,
      report_for: userRole==="advisor" ? [parseInt(userId)] : advisorName.length>0 ? advisorName.map((i) => i.user_id) :"all",
      test_type_id: testType,
      sub_test_type_id: subTestType,
      filter_type: headerFilter,
      month: monthname,
      country_id: countryName
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/enrollment-collection-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

       const result = await response.json();
      if (response.ok) {
       

        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(headerName, headerFilter);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setRevenueData([]);
        setLoading(false);
      }
      else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };

  const renderPopupComponent = () => {
  switch (selectedcardFilter) {
    case "collected_revenue":
      return (
        <MoreCardDetails
          onClose={handleCloseDetailPopup}
          selectedFilter="default"
          SelectedCardData={SelectedCardData}
          selectedCardName={selectedCardName}
          selectedCountFilter={selectedcardFilter}
          selectedYear={selectedYear?.year}
          monthName={monthname}
        />
      );
  case "total_revenue":
      return (
        <MoreCardDetails
          onClose={handleCloseDetailPopup}
          selectedFilter="default"
          SelectedCardData={SelectedCardData}
          selectedCardName={selectedCardName}
          selectedCountFilter={selectedcardFilter}
          selectedYear={selectedYear?.year}
          monthName={monthname}
          countryId={countryName}
        />
      );

    case "test_bookings":
    case "test_revenue":
      return (
        <MiscellaneousComp
          onClose={handleCloseDetailPopup}
          selectedFilter="default"
          SelectedCardData={SelectedCardData}
          selectedYear={selectedYear?.year}
          monthName={monthname}
        />
      );
      
    // Add more cases as needed
    default:
      return (
        <EnrollDetails
          onClose={handleCloseDetailPopup}
          selectedFilter="default"
          SelectedCardData={SelectedCardData}
          selectedYear={selectedYear?.year}
          monthName={monthname}
        />
      );
  }
};

  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Stack direction="row" spacing={1}>
          <Typography
            variant="h4"
            color="secondary"
            fontWeight={800}
            marginRight={2}
          >
            Fetching
          </Typography>
          <CircularProgress color="primary" />
        </Stack>
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} md={4} lg={3}>
          <HeadingCard label="Test Type Wise Report" />
        </Grid>
        {userRole === "center_admin" && (
          <Grid item xs={12} sm={7} md={8} lg={9} textAlign="end">
            <Button
              color="secondary"
              size="small"
              variant="contained"
              style={{ borderRadius: "25px" }}
              startIcon={<DownloadIcon />}
              onClick={handleView}
            >
              Download Report
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              {userRole === "center_admin" && (
                <>
  <Grid item xs={12} sm={4} md={3}>
                    <Typography variant="h6">Select Country</Typography>
                    <CustomTextFieldComp
                      size="normal"
                      select
                      value={countryName}
                      onChange={handleChangeCountry}
                      fullWidth
                      InputProps={{ style: { borderRadius: "10px" } }}
                    >
                      {countryList?.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.country_name}
                        </MenuItem>
                      ))}
                    </CustomTextFieldComp>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Branch</Typography>
                    <CustomAutocompleteComp
                      size="small"
                      value={branchName}
                      multiple
                      onChange={handleBranchChange}
                      options={allBranchList}
                     getOptionLabel={(option) => option.branch_name}
                    tooltipContent={(option) => option.branch_name}
                    placeholder="Please Select Branches"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { borderRadius: "14px" }, // Add borderRadius here
                          }}
                          size="small"
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          style={{
                            backgroundColor: selected ? "#e0f7fa" : "inherit",
                          }}
                        >
                          {option.branch_name}
                        </li>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Advisor Status</Typography>
                    <CustomAutocompleteComp
                      multiple
                      value={status}
                      onChange={handleStatusChange}
                      size="small"
                      options={allStatusList}
                      getOptionLabel={(option) => option.name}
                      tooltipContent={(option) => option.name}
                        placeholder="Please Select Status"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Advisor</Typography>
                    <CustomAutocompleteComp
                      size="small"
                      value={advisorName}
                      multiple
                      onChange={handleUserChange}
                    noOptionsText={
                        status.length > 0
                          ? allAdvisorList.length === 0
                            ? "No Advisor Available"
                            : ""
                          : "Please Select Advisor Status First"
                      }
                      options={allAdvisorList}
                      getOptionLabel={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                      tooltipContent={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                           placeholder="Please Select Advisor"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { borderRadius: "14px" }, // Add borderRadius here
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.user_id === value.user_id
                      }
                      renderOption={(props, option, { selected }) => {
                        return (
                          <li
                            {...props}
                            style={{
                              backgroundColor: selected ? "#e0f7fa" : "inherit",
                            }}
                          >
                            {option.first_name} {option.last_name}
                          </li>
                        );
                      }}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} sm={6} md={3} lg={3}>
                <Typography variant="h6">Select Year</Typography>
                <CustomAutocompleteComp
                fullWidth
                  value={selectedYear}
                  onChange={(event, value) => handleselectedYear(value)}
                  size="small"
                  options={years}
                  getOptionLabel={(option) => option.year}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        style: { borderRadius: "14px" }, // Add borderRadius here
                      }}
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={userRole === "advisor" ? 3 : 3}
                textAlign= {userRole !== "advisor" ? "start" :"start"}
              >
                <Typography sx={{ visibility: "hidden" }}>
                  Spacing purpose
                </Typography>
                <SearchButton
                  size="small"
                  showIcon={true}
                  onClick={() => handleSearchData(monthname)}
                />

                {/* <Button
                  variant="contained"
                  color="error"
                  size="small"
                  style={{ borderRadius: "25px", marginLeft: "10px" }}
                  onClick={handleclear}
                  startIcon={<ClearIcon />}
                >
                  Clear
                </Button> */}
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Stack
                  display="flex"
                  flexDirection="row"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography
                    style={{
                      cursor: "pointer",
                      display: "inline-flex", // Align content inside
                      justifyContent: "center",
                      alignItems: "center",
                      width: "25px", // Set width and height for circle
                      height: "25px",
                      borderRadius: "50%", // Makes the element circular
                      backgroundColor: "#00C853", // Optional: add background color
                      border: "1px solid #ccc", // Optional: add border

                      opacity: currentMonthIndex === 0 ? 0.5 : 1,
                    }}
                    onClick={handlePreviousMonth}
                  >
                    <ArrowBackIcon
                      style={{ color: "white", fontSize: "1rem" }}
                    />
                  </Typography>

                  <Typography variant="h4">
                    {monthname} {selectedYear?.year}
                  </Typography>
                  <Typography
                    style={{
                      cursor: "pointer",
                      display: "inline-flex", // Align content inside
                      justifyContent: "center",
                      alignItems: "center",
                      width: "25px", // Set width and height for circle
                      height: "25px",
                      borderRadius: "50%", // Makes the element circular
                      backgroundColor: "#00C853", // Optional: add background color
                      border: "1px solid #ccc", // Optional: add border
                      opacity:
                        currentMonthIndex === monthList.length - 1 ? 0.5 : 1,
                    }}
                    onClick={handleNextMonth}
                  >
                    <ArrowForwardIcon
                      style={{ color: "white", fontSize: "1rem" }}
                    />
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <StyledTableContainer component={Paper} borderLeft={true}>
                  <Table
                    sx={{ minWidth: 650, tableLayout: "fixed" }}
                    aria-label="simple table"
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Test Name</TableCell>
                                         <TableCell>Currency</TableCell>
                        <TableCell>Total Enrolments</TableCell>
                        <TableCell>Online Enrolments</TableCell>
                        <TableCell>Offline Enrolments</TableCell>
              
                        <TableCell>Collected Revenue</TableCell>
                         <TableCell>Test Booked</TableCell>
                          <TableCell>Test Revenue</TableCell>
                            <TableCell>Total Revenue</TableCell>
                      </TableRow>
                    </TableHead>

                    {revenueData?.length === 0 ? (
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="h6">No data available</Typography>
                      </Grid>
                    ) : (
                      revenueData?.map((row, index) => {
                        const islastRow = index === revenueData.length - 1;
                        return (
                          <TableBody>
                            <TableRow
                              key={row.name}
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#f0f0f0" : "inherit",
                              }}
                            >
                              <TableCell
                                style={{
                                  borderLeft: "0.1px solid #C3C3C3",
                                  color: islastRow ? "black" : "inherit",
                                  fontWeight: islastRow ? 700 : 500,
                                }}
                              >
                                {row?.test_type}{" "} <br/>
                                {row.sub_test_type !== ""
                                  ? `(${row.sub_test_type})`
                                  : ""}
                              </TableCell>
                                  <TableCell>{row?.currency}</TableCell>
                              <TableCell
                                style={{
                                  color: islastRow ? "black" : "blue",
                                  fontWeight: islastRow ? 700 : 500,
                                  cursor: islastRow ? "" : "pointer",
                                }}
                                onClick={() =>
                                  islastRow
                                    ? " undefined"
                                    : getCardMoreInfo(
                                        "Total Enrolments",
                                        "total_enrolments",
                                        row?.test_type_id,
                                        row?.sub_test_type_id
                                      )
                                }
                              >
                                {row?.total_enrollments}
                              </TableCell>
                              <TableCell
                                style={{
                                  color: islastRow ? "black" : "blue",
                                  fontWeight: islastRow ? 700 : 500,
                                  cursor: islastRow ? "" : "pointer",
                                }}
                                onClick={() =>
                                  islastRow
                                    ? " undefined"
                                    : getCardMoreInfo(
                                        "Online Enrolments",
                                        "online_enrolments",
                                        row?.test_type_id,
                                        row?.sub_test_type_id
                                      )
                                }
                              >
                                {row?.online_enrollments}{" "}
                              </TableCell>

                              <TableCell
                                style={{
                                  color: islastRow ? "black" : "blue",
                                  fontWeight: islastRow ? 700 : 500,
                                  cursor: islastRow ? "" : "pointer",
                                }}
                                onClick={() =>
                                  islastRow
                                    ? " undefined"
                                    : getCardMoreInfo(
                                        "Offline Enrolments",
                                        "offline_enrolments",
                                        row?.test_type_id,
                                        row?.sub_test_type_id
                                      )
                                }
                              >
                                {row?.offline_enrollments}
                              </TableCell>


                              <TableCell
                            
                                style={{
                                  color: islastRow ? "black" : "blue",
                                  fontWeight: islastRow ? 700 : 500,
                                  cursor: islastRow ? "" : "pointer",
                                }}
                                onClick={() =>
                                  islastRow
                                    ? " undefined"
                                    : getCardMoreInfo(
                                        "Collected Revenue",
                                        "collected_revenue",
                                        row?.test_type_id,
                                        row?.sub_test_type_id
                                      )
                                }
                              >
                                {row?.collected_revenue}
                              </TableCell>
                               <TableCell
                             
                                style={{
                                  color: islastRow ? "black" : "blue",
                                  fontWeight: islastRow ? 700 : 500,
                                  cursor: islastRow ? "" : "pointer",
                                }}
                                onClick={() =>
                                  islastRow
                                    ? " undefined"
                                    : getCardMoreInfo(
                                        "Test Bookings",
                                        "test_bookings",
                                        row?.test_type_id,
                                        row?.sub_test_type_id
                                      )
                                }
                              >
                                {row?.test_bookings}
                              </TableCell>
                               <TableCell
                              
                                style={{
                                  color: islastRow ? "black" : "blue",
                                  fontWeight: islastRow ? 700 : 500,
                                  cursor: islastRow ? "" : "pointer",
                                }}
                                onClick={() =>
                                  islastRow
                                    ? " undefined"
                                    : getCardMoreInfo(
                                        "Test Revenue",
                                        "test_revenue",
                                        row?.test_type_id,
                                        row?.sub_test_type_id
                                      )
                                }
                              >
                                {row?.test_revenue}
                              </TableCell>


                                    <TableCell
                                sx={{ borderRight: "0.1px solid #C3C3C3" }}
                                style={{
                                  color: islastRow ? "black" : "blue",
                                  fontWeight: islastRow ? 700 : 500,
                                  cursor: islastRow ? "" : "pointer",
                                }}
                                onClick={() =>
                                  islastRow
                                    ? " undefined"
                                    : getCardMoreInfo(
                                        "Total Revenue",
                                        "total_revenue",
                                        row?.test_type_id,
                                        row?.sub_test_type_id
                                      )
                                }
                              >
                                {row?.total_revenue}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        );
                      })
                    )}
                  </Table>
                </StyledTableContainer>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={renderPopupComponent()}
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />
    </>
  );
}
